module.exports = __webpack_public_path__ + "static/media/a5.b1c7f8cb.jpg";